import { c as _c } from "react/compiler-runtime";
/**
 * RelatedBox Component
 *
 * Sidebar box with related links. Matches production `.hotbox` styling:
 *   - Cream background (#FCE7D4)
 *   - 6px solid orange left border
 *   - 5px border-radius
 *   - 20px padding
 *   - Soft box shadow
 *   - Navy bold "Related" heading (H2)
 *   - Orange bullets + orange link text
 *
 * Token source: src/styles/design-system.css
 *   --color-scw-hotbox: #FCE7D4
 *   --color-scw-orange: #EB8322
 *   --color-scw-section: #313450
 */

import Link from 'next/link';
import { cn } from '@/lib/utils';
interface RelatedLink {
  /** Link text */
  label: string;
  /** Link URL */
  href: string;
  /** Open in new tab */
  external?: boolean;
}
interface RelatedBoxProps {
  /** Box title (default: "Related") */
  title?: string;
  /** Array of related links */
  links: RelatedLink[];
  /** Additional CSS classes */
  className?: string;
}
export function RelatedBox(t0) {
  const $ = _c(12);
  const {
    title: t1,
    links,
    className
  } = t0;
  const title = t1 === undefined ? "Related" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("bg-scw-hotbox border-l-[6px] border-scw-orange rounded-[5px] p-5", "shadow-[0_5px_5px_rgba(0,0,0,0.2)]", "transition-[border-color] duration-300 ease-out", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <h2 className="text-h3 font-bold text-scw-section mb-4">{title}</h2>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== links) {
    t4 = links.map(_temp);
    $[4] = links;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <ul className="space-y-2.5">{t4}</ul>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t5) {
    t6 = <aside className={t2}>{t3}{t5}</aside>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(link, index) {
  const isExternal = link.external || link.href.startsWith("http");
  return <li key={index} className="flex items-start"><span aria-hidden="true" className="mr-2 mt-2 w-1.5 h-1.5 rounded-full flex-shrink-0 bg-scw-orange" />{isExternal ? <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-[17px] leading-snug text-scw-orange hover:text-scw-orange-hover hover:underline">{link.label}</a> : <Link href={link.href} className="text-[17px] leading-snug text-scw-orange hover:text-scw-orange-hover hover:underline">{link.label}</Link>}</li>;
}